var _circle, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtFechar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.5,
    r: 26.5,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.8108,
    y: 15.5679,
    width: 28.972,
    height: 1.81075,
    transform: "rotate(45 16.8108 15.5679)",
    fill: "#FF0077"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 35.4863,
    width: 28.972,
    height: 1.81075,
    transform: "rotate(-45 15 35.4863)",
    fill: "#FF0077"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtFechar);
export default __webpack_public_path__ + "static/media/bt-fechar.96e6533b65ad48f2f6f0a1b73437c647.svg";
export { ForwardRef as ReactComponent };